export function BoxCareer({ item }) {
	return (
		<div className='tw-flex tw-flex-wrap tw-items-center tw-gap-x-2'>
			<span className={`tw-flex tw-gap-1 tw-text-base tw-items-center tw-text-gray-700`}>{item.level.value}</span>
			<span className={`tw-flex tw-gap-1 tw-text-base tw-items-center tw-text-gray-500`}>{item.subarea?.value}</span>
		</div>
	)
}
